import React, { useEffect, useState } from "react";
import { Spin, Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link } from "react-router-dom";
import backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import InputLabel from "@mui/material/InputLabel";
import { TextField } from "@mui/material";
import { addFaq, deleteFaq, editFaq, getFaq } from "../../../service/api";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import { sanitizeInput, validateTitle, validateDescription, decryptString } from "../../../config/validation";
import moment from "moment";
import { triggerDownload } from "../../../config/downloadUtils";

const formatDate = (val) =>
  val ? moment(val).format("DD/MM/YYYY HH:mm") : "-";

const ALL_COLUMNS = [
  {
    key: "title",
    title: "Title",
    defaultVisible: true,
    render: (r) => r?.title || "-",
  },
  {
    key: "description",
    title: "Description",
    defaultVisible: true,
    render: (r) => r?.description || "-",
  },
  {
    key: "createdAt",
    title: "Date",
    defaultVisible: true,
    render: (r) => formatDate(r?.createdAt),
  },
  {
    key: "updatedAt",
    title: "Updated",
    defaultVisible: false,
    render: (r) => formatDate(r?.updatedAt),
  },
];

const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 290,
  background: "white",
  // border: '1px solid #000',
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

const FAQ = () => {
  const [roleInput, setroleInput] = useState({
    name: "",
    description: "",
  });
  const [roleInputError, setroleInputError] = useState({
    name: "",
    description: "",
  });
  const [list, setList] = useState([]);
  const [user, setUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const [id, setId] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "faq-list",
    allColumns: ALL_COLUMNS,
  });

  const roleChange = (e) => {
    const { name, value } = e.target;
    // Store raw value and sanitize only on submit
    setroleInput({ ...roleInput, [name]: value });
    setroleInputError({ ...roleInputError, [e.target.name]: "" });
  };

  const getList = () => {
    let body = {
      page: page,
      sizePerPage: pageSize,
      pagination: true,
    };
    if (searchTerm) {
      body.search = searchTerm;
    }

    setLoading(true);
    getFaq(body)
      .then((res) => {
        if (res?.status) {
          setList(res?.data);
        }
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = (format) => {
    const body = { pagination: false };
    if (searchTerm) body.search = searchTerm;
    setDownloadLoading(true);
    getFaq(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "faq");
      })
      .finally(() => setDownloadLoading(false));
  };


  const handleClear = () => {
    setroleInput({
      ...roleInput,
      name: "",
      description: "",
    });
    setroleInputError({
      name: "",
      description: "",
    });
  };
  // ADD USER FUNCTION
  const handleAdd = async () => {
    let hasError = false;
    let errors = {
      name: "",
      description: "",
    };

    // Validate title using validation function
    const titleError = validateTitle(roleInput?.name, {
      minLength: 3,
      maxLength: 100,
      fieldName: "Title",
    });
    if (titleError) {
      errors.name = titleError;
      hasError = true;
    }

    // Validate description using validation function
    const descriptionError = validateDescription(roleInput?.description, {
      minLength: 10,
      maxLength: 1000,
      fieldName: "Description",
      required: true,
    });
    if (descriptionError) {
      errors.description = descriptionError;
      hasError = true;
    }

    if (hasError) {
      setroleInputError(errors);
      return;
    }

    const plainData = {
      title: sanitizeInput(roleInput?.name),
      description: sanitizeInput(roleInput?.description),
    };
    const encryptedData = await decryptString(plainData);
    const payload = { encrypt: encryptedData };

    setLoading(true);
    if (!edit) {
      addFaq(payload)
        .then((res) => {
          if (res?.status) {
            toast.success(res?.message, { toastId: 'faq-add-success' });
            setUser(false);
            getList();
            handleClear();
          } else {
            toast.error(res?.message, { toastId: 'faq-add-error' });
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message, { toastId: 'faq-add-error' });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      editFaq(id?._id, payload)
        .then((res) => {
          if (res?.status) {
            toast.success(res?.message, { toastId: 'faq-update-success' });
            setEdit(false);
            setUser(false);
            getList();
            handleClear();
          } else {
            toast.error(res?.message, { toastId: 'faq-update-error' });
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message, { toastId: 'faq-update-error' });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  // DELETE USER FUNCTION

  const handleDeleteFunction = () => {
    setLoading(true);
    deleteFaq(id?._id)
      .then((res) => {
        if (res?.status) {
          toast.success(res?.message, { toastId: 'faq-delete-success' });
          handleCloseDelete();
          getList();
          setId(null);
        } else {
          toast.error(res?.message, { toastId: 'faq-delete-error' });
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message, { toastId: 'faq-delete-error' });
      })
      .finally((res) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getList();
  }, [page, pageSize, searchTerm]);

  // Reset to page 1 whenever filters or page size change.
  useEffect(() => {
    setPage(1);
  }, [pageSize, searchTerm]);

  const actionColumn = {
    key: "__action",
    title: "Action",
    className: "text-end",
    render: (_, row) => (
      <div className="text-end">
        <a
          className="me-1 btn btn-sm bg-success-light "
          onClick={() => {
            setId(row);
            handleClear();
            setUser(true);
            setEdit(true);
            setroleInput({
              ...roleInput,
              name: row?.title,
              description: row?.description,
            });
          }}
        >
          <i className="fe fe-pencil"></i> Edit
        </a>
        <a
          onClick={() => {
            handleOpenDelete();
            setId(row);
          }}
          className="me-1 btn btn-sm bg-danger-light"
        >
          <i className="fe fe-trash"></i> Delete
        </a>
      </div>
    ),
  };

  const columns2 = [...dynamicColumns, actionColumn];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-aut0">
                <h3 className="page-title">FAQ</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">FAQ</li>
                </ul>
              </div>
              {!user && (
                <div className="col-sm-5 col">
                  <a
                    onClick={() => {
                      handleClear();
                      setEdit(false);
                      setUser(true);
                    }}
                    data-bs-toggle="modal"
                    className="btn btn-primary float-end mt-2"
                  >
                    Add FAQ
                  </a>
                </div>
              )}
            </div>
          </div>

          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              {user ? (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0px",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <FaArrowLeft
                        style={{
                          marginTop: "3px",
                          cursor: "pointer",
                          width: "30px",
                          height: "20px",
                        }}
                        onClick={() => {
                          setEdit(false);
                          setUser(false);
                        }}
                      />
                      <h4>{edit ? "Edit FAQ" : "Add FAQ"}</h4>
                    </div>{" "}
                    <div
                      style={{
                        // borderTop: "1px solid grey",
                        height: "56px",
                        display: "flex",
                        justifyContent: "end",
                        // marginTop: "30px",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        onClick={handleAdd}
                        disabled={loading}
                        style={{ marginBottom: "10px", marginTop: "9px" }}
                      >
                        {loading ? (
                          <Spinner size="sm" />
                        ) : edit ? (
                          "Update"
                        ) : (
                          "Add"
                        )}
                      </button>
                    </div>
                  </div>
                  <div style={{ margin: "10px" }} className="page-grid">
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Title &nbsp;
                        {roleInputError?.name && (
                          <small style={{ color: "red" }}>
                            {roleInputError?.name}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="text"
                        placeholder="Title"
                        value={roleInput?.name}
                        onChange={roleChange}
                        name="name"
                        id="name"
                        error={!!roleInputError?.name}
                      />
                    </div>
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Description &nbsp;
                        {roleInputError?.description && (
                          <small style={{ color: "red" }}>
                            {roleInputError?.description}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="text"
                        placeholder="Description"
                        value={roleInput?.description}
                        onChange={roleChange}
                        name="description"
                        id="description"
                        error={!!roleInputError?.description}
                        multiline
                        rows={4}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="list-layout">
                  <div className="list-layout__main">
                    <div className="card">
                      <div className="card-body">
                        <TableToolbar
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          pageSizeOptions={pageSizeOptions}
                          total={list?.total}
                          page={page}
                          visibleColumnKeys={visibleColumnKeys}
                          allColumns={ALL_COLUMNS}
                          toggleColumn={toggleColumn}
                          resetColumns={resetColumns}
                          onDownload={handleDownload}
                          downloadLoading={downloadLoading}
                        />
                        <div className="table-responsive">
                          {loading ? (
                            <div className="his-spin">
                              <Spin
                                size="large"
                                style={{ position: "relative", top: "35%" }}
                              />
                            </div>
                          ) : (
                            <Table
                              pagination={false}
                              style={{ overflowX: "auto" }}
                              columns={columns2}
                              dataSource={
                                list?.result ? list.result : list || []
                              }
                              rowKey={(record) => record._id || record.id}
                            />
                          )}
                          {list && list?.total > pageSize && (
                            <CustomPagination
                              key={`pg-${pageSize}`}
                              totalTabs={list?.total}
                              tabsPerPage={pageSize}
                              handleChange={setPage}
                              className={`${
                                loading ? "display-hide" : "display-flex"
                              }`}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="list-layout__filters">
                    <FilterPanel
                      count={list?.total}
                      onClear={() => {
                        setSearchTerm("");
                      }}
                    >
                      <FilterPanel.Field label="Search">
                        <input
                          type="text"
                          placeholder="Title or description"
                          value={searchTerm}
                          onChange={(e) =>
                            setSearchTerm(sanitizeInput(e.target.value))
                          }
                        />
                      </FilterPanel.Field>
                    </FilterPanel>
                  </div>
                </div>
              )}
            </div>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDelete}
            onClose={handleCloseDelete}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openDelete}>
              <Box style={styleDelete}>
                <div style={{ margin: "10px", textAlign: "center" }}>
                  Please confirm before deleting
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    className="btn btn-danger"
                    disabled={loading}
                    onClick={handleDeleteFunction}
                    style={{ marginBottom: "10px", marginTop: "15px" }}
                  >
                    {loading ? <Spinner size="sm" /> : "Delete"}
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleCloseDelete}
                    style={{
                      marginLeft: "7px",
                      marginBottom: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default FAQ;
